import type IExportRepository from '@/core/domain/exports/IExportRepository.ts'
import type ExportFilterSchool from '@/core/domain/exports/ExportFilterSchool.ts'

export default class FetchAllExportFiltersUseCase {
  private readonly exportRepository: IExportRepository

  constructor(exportRepository: IExportRepository) {
    this.exportRepository = exportRepository
  }

  async execute(schoolYearId: number): Promise<ExportFilterSchool[]> {
    return await this.exportRepository.fetchDataFiltersBySchoolYearId(schoolYearId)
  }
}